import axios from "axios";
import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

/**
 * @param {string} id - invite slug
 * @param {{ phone?: string, email?: string }} payload - exactly one of phone or email
 */
const requestOtp = async (id, payload) => {
  const response = await axios.post(
    routes.inviteflowRequestOtp(id),
    payload,
    AXIOS_DEFAULT_CONFIG
  );
  return response;
};

export default requestOtp;
